<template>
  <div id="">
    <div class="header">
      <div class="herder_text_left">
        <!-- <img :src="hostUrl + schoolData.schoolLogo" /> -->
        <!-- <img class="logo" src="@/assets/img/login/logo.png" /> -->
        {{ schoolName?schoolName:'学生发展与综合素质评价平台' }}
      </div>
      <div class="hearder_right">
        <!-- <add-bookss
          v-show="roleTypes == 'teacher' ? true : false"
          class="header_btn"
        ></add-bookss> -->
        <div
          @click="workTai"
          class="gongzuo"
          v-show="path == '/teacherbasic' ? true : false"
        >
          工作台
        </div>
        <div class="hearder_right_user">
          <span v-if="roleType == 'teacher' ? true : false">
            <el-image
              class="imglogo"
              :src="hostUrl + userDatas.headPhotoUrl"
              fit="cover"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </span>

          <el-popover placement="bottom-end" trigger="hover">
            <!-- <el-divider v-if="roleType == 'teacher' ? true : false"></el-divider> -->
            <ul class="header_right_se">
              <!-- <li
          v-for="item in roleByUserData"
          :key="item.id"
          v-show="item.id == roleTypeId ? false : true"
          @click="qiehuan(item.id)"
        >
          {{ item.name }}
        </li> -->

              <li
                v-if="roleType == 'teacher' ? true : false"
                @click="$router.push('/teacherbasic')"
              >
                <i class="icon el-icon-user" />
                个人资料
              </li>
              <li @click="xgpassword">
                <i class="icon el-icon-lock" />
                修改密码
              </li>
              <li @click="unLogin" class="">
                <i class="icon el-icon-lock" />
                退出登录
              </li>
            </ul>
            <div slot="reference" class="nameBtn">
              {{ userDatas.name }}
              <i class="el-icon-caret-bottom"></i>
            </div>
          </el-popover>
        </div>
      </div>
    </div>

    <!-- 修改密码 -->
    <el-dialog
      :visible.sync="visible"
      title="修改密码"
      width="800px"
      :lock-scroll="true"
      :center="true"
    >
      <el-form ref="passform" :model="passform" label-width="120px">
        <el-form-item
          label="原始密码"
          prop="oldPassword"
          :rules="[
            { required: true, message: '密码不能为空', trigger: 'blur' },
            { min: 6, message: '密码必须为6位以上', trigger: 'blur' }
          ]"
        >
          <el-input
            size="small"
            v-model="passform.oldPassword"
            type="password"
          />
        </el-form-item>
        <el-form-item
          prop="newPassword"
          label="新密码"
          :rules="[
            { required: true, message: '密码不能为空', trigger: 'blur' },
            { min: 6, message: '密码必须为6位以上', trigger: 'blur' }
          ]"
        >
          <el-input
            size="small"
            v-model="passform.newPassword"
            type="password"
          />
        </el-form-item>
        <el-form-item
          label="确认新密码"
          prop="newPassword1"
          :rules="[
            {
              validator: checkPassword,
              required: true,
              trigger: 'blur'
            },
            { min: 6, message: '密码必须为6位以上', trigger: 'blur' }
          ]"
        >
          <el-input
            size="small"
            v-model="passform.newPassword1"
            type="password"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelpass">取消</el-button>
        <el-button size="small" type="primary" @click="submitpass"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
// $router.push('/bench')
import addBookss from '../bench/components/addbook'
import {
  usercenterinfo,
  schoolgetinfo,
  getBookList,
  deleteBook,
  getBookSubjectList,
  getVersionList,
  getVolumeList,
  getChaptertreeVo,
  addBook,
  getMyappList,
  UserLogout,
  modifyPassWord,
  roleByUser,
  homeUrl
} from '@/api/home'
export default {
  components: {
    addBookss
  },
  data() {
    return {
      userData: [],
      userDatas: [],
      schoolData: [],
      visible: false,
      token: localStorage.getItem('token'),
      schoolId: 0,
      roleType: localStorage.getItem('roleType'),
      roleTypes: localStorage.getItem('roleTypes'),
      hostUrl: '', //根路径
      passform: {
        oldPassword: '',
        newPassword: '',
        newPassword1: ''
      },
      path: '',
      roleByUserData: [],
      roleTypeId: 0,
      url: homeUrl,
      schoolName:''
    }
  },
  created() {
    this.usercenterinfo()
    this.roleByUser()
    this.path = this.$route.path
  },
  methods: {
    //   获取当前用户登陆信息
    async usercenterinfo() {
      const { data: res } = await usercenterinfo()
      this.userData = res.data
      this.schoolId = res.data.schoolId
      localStorage.setItem('schoolIds', res.data.schoolId)
      this.hostUrl = res.data.hostUrl
      this.$emit('hostUrl', this.hostUrl)
      this.schoolgetinfo()
      this.schoolName=res.data.schoolName
      if (this.roleType == 'teacher' || this.roleTypes == 'teacher') {
        this.userDatas = res.data.teacher
        localStorage.setItem('schoolName', res.data.teacher.schoolName)
        this.schoolName=res.data.teacher.schoolName
        if (this.userDatas.classesVo) {
          localStorage.setItem('classId', res.data.teacher.classesVo.id)
          localStorage.setItem('gradeId', res.data.teacher.classesVo.gradeId)
        }
      } else if (this.roleType == 'school' && this.roleTypes == 'school') {
        this.userDatas = res.data.school
        localStorage.setItem('schoolName', res.data.school.schoolName)
        this.schoolName=res.data.school.schoolName
      }
    },
    // 获取自己全部角色
    async roleByUser() {
      const roles = localStorage.getItem('roleType')
      if (roles == 'teacher') {
        this.roleTypeId = -1003
      } else {
        this.roleTypeId = -1004
      }
      this.$emit('roleType', this.roleTypeId)
      const { data: res } = await roleByUser()
      console.log('roleByUser', res)
      this.roleByUserData = res.data
    },
    // 获取当前登陆用户的学校信息
    async schoolgetinfo() {
      const { data: res } = await schoolgetinfo({
        id: this.schoolId
      })
      this.schoolData = res.data
    },
    xgpassword() {
      this.visible = true
    },
    gozuo() {
      let urlss = localStorage.getItem('url') + 'bench?token=' + localStorage.getItem('token')
      window.open(urlss, '_self')
    },

    workTai() {
      let urlss = localStorage.getItem('url') + 'home?token=' + localStorage.getItem('token')
      window.open(urlss, '_self')
    },

    // 退出登陆
    async unLogin() {
      // const confirResult = await this.$confirm('您确定要退出吗？', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).catch(err => err)
      // if (confirResult !== 'confirm') {
      //   return this.$message.info('已取消！！')
      // }
      // const res = await UserLogout()
      // localStorage.clear()
      // sessionStorage.clear()
      let urls = localStorage.getItem('url')
      window.open(urls, '_self')
    },

    checkPassword(rule, value, callback) {
      if (!value) {
        return callback(new Error('二次密码不能为空'))
      } else {
        if (this.passform.newPassword !== this.passform.newPassword1) {
          return callback(new Error('两次密码必须输入一致'))
        } else {
          callback()
        }
      }
    },

    cancelpass() {
      this.resetForm('passform')
      this.visible = false
    },

    submitpass() {
      this.$refs.passform.validate(valid => {
        if (valid) {
          this.ApiModifyPassByOld()
        } else {
          this.$message.error('请检查信息是否填写正确')
          return false
        }
      })
    },
    ApiModifyPassByOld() {
      const { passform } = this
      modifyPassWord({ ...passform }).then(res => {
        this.$message.success('修改成功,下次登录请使用新密码登录')
        this.visible = false
        this.resetForm('passform')
      })
    },
    qiehuan(id) {
      this.roleTypeId = id
      if (id == '-1003') {
        localStorage.setItem('roleType', 'teacher')
      } else {
        localStorage.setItem('roleType', 'school')
      }
      this.$emit('roleType', id)
    }
  }
}
</script>
<style>
.el-popover {
  min-width: 80px !important;
  top: 50px !important;
  /* margin-top: 0; */
}
.popper__arrow {
  left: 75% !important;
}
</style>
<style scoped>
.header {
  background: #006eff;
  color: #fff;
  height: 60px !important;
  box-shadow: 0 2px 4px 0 rgba(1, 0, 0, 0.1);
  display: flex;
}
.header img {
  margin-top: 5px;
  margin-left: 30px;
  height: 50px;
}
.herder_text_left {
  flex: 1;
  padding-left: 24px;
  height: 60px;
  display: flex;
  align-items: center;
  font-size: 18px !important;
  font-weight: 600;
  color: #ffffff;
}
.hearder_right {
  float: right;
  height: 60px;
  cursor: pointer;
  padding: 0 24px;
}
.header_btn {
  float: left;
  margin-top: 4px;
}
.hearder_right_user {
  float: right;
  margin-left: 24px;
  height: 60px;
  display: flex;
  align-items: center;
}

.imglogo {
  width: 40px;
  height: 40px;
  text-align: center;
  border-radius: 50%;
  margin-right: 24px;
}
.username {
  float: right;
  font-size: 16px;
  /* margin-top: 10px; */
  margin-left: 15px;
}
.header_right_se li {
  list-style: none;
  height: 30px;
  font-size: 14px;
  line-height: 30px;
  text-align: center;
  margin-bottom: 10px;
  cursor: pointer;
}
.header_right_se li:hover {
  background-color: #e1efff;
}
.gongzuo {
  height: 60px;
  line-height: 60px;
  display: inline-block;
  font-size: 14px;
  margin-left: 20px;
  cursor: pointer;
}
.popovername {
  height: 40px;
  line-height: 40px;
  padding: 0 32px;
}
.imglogo {
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 50%;
}
.usernames {
  float: left;
  display: inline-block;
  width: 60px;
  font-size: 14px;
  /* margin-top: 10px; */
  margin-left: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-divider {
  margin: 10px 0;
}
.unLogin {
  background-color: #409eff;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/header/header.vue